<template>
  <section>
    <b-container fluid>
      <b-row class="align-items-center">
        <b-col class="px-0 mx-0" lg="6" xl="6" sm="12">
          <slot name="pr-1" />
          <div class="banner_text d-flex flex-column justify-content-center">
            <div class="banner_text_iner">
              <slot name="th1" />
              <slot name="th2" />
              <slot name="th3" />
              <slot name="th4" />
            </div>
          </div>
        </b-col>
        <b-col lg="6" xl="6" sm="12">
          <slot name="pl-1" />
        </b-col>
      </b-row>
    </b-container>
  </section>
</template>

<script>
export default {
  name: "S20",
};
</script>

<style>


</style>